<div class="expandable-text">
  <p
    class="text"
    [class.collapsed]="!expanded"
    [style.-webkit-line-clamp]="!expanded ? maxLines : 'unset'"
  >
    {{ text || "Non renseigné" }}
  </p>

  <button
    *ngIf="text && text.length > 0"
    type="button"
    class="toggle"
    (click)="toggle()"
    [attr.aria-expanded]="expanded"
  >
    <span>{{ expanded ? "Voir moins" : "Voir plus" }}</span>
    <span class="icon" [class.rotated]="expanded">▼</span>
  </button>
</div>
